import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import { usePostFetcher } from '@api/post.api';
import { useAccountStore } from '@stores/account.store';
import type { PostInterface } from '@/components/modules/Post/post.interface';

export const usePostStore = defineStore('post', () => {
  const postId = ref('');
  const postFetcher = usePostFetcher();
  const accountStore = useAccountStore();

  const postList = computed(() => {
    return (
      postFetcher.list.data?.value?.filter((post: PostInterface) => {
        return !post.hideFromFeed;
      }) ?? []
    );
  });

  const fetchPost = async (id: string) => {
    await postFetcher.one.execute({ id }, accountStore.authToken);
  };

  const fetchPostList = async (postCollectionId?: string, includeContent?: string) => {
    await postFetcher.list.execute({ postCollectionId, includeContent }, accountStore.authToken);
  };

  return {
    postId,

    post: postFetcher.one.data,
    postError: postFetcher.one.error,
    isPostFetching: postFetcher.one.isFetching,
    fetchPost,
    resetPost: postFetcher.one.resetOne,

    postList,
    postListError: postFetcher.list.error,
    isPostListFetching: postFetcher.list.isFetching,
    fetchPostList,
    resetPostList: postFetcher.list.resetList,
  };
});
